export const UserGroup = {
  'tdeUser': 'TDE USER',
  'coachDealer': 'COACH DEALER',
  'adviserDealer': 'ASESOR DEALER',
};
